import { render, staticRenderFns } from "./PcTextareaReskinned.vue?vue&type=template&id=55b8dde4"
import script from "./PcTextareaReskinned.vue?vue&type=script&lang=js"
export * from "./PcTextareaReskinned.vue?vue&type=script&lang=js"
import style0 from "./PcTextareaReskinned.vue?vue&type=style&index=0&id=55b8dde4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
